<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters"  ref="filters">
          <el-form-item prop="value2">
            <el-date-picker v-model="filters.value2" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearch('filters')">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('filters')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table :data="users" highlight-current-row v-loading="loading" style="width: 100%">
        <el-table-column fixed label="序号" type="index"></el-table-column>
        <el-table-column prop="memberName" label="会员姓名"></el-table-column>
        <el-table-column prop="luckname" label="抽中奖品"></el-table-column>
        <el-table-column prop="createtime" label="抽奖时间"></el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
    </el-col>
  </el-row>
</template>
<script>
import API from "../../../api/frbasicapi/member";
export default {
  data() {
    return {
      filters: {
        value2: "",
      },
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      users: []
    };
  },
  methods: {

        //性别显示转换
    formatSex: function (row, column) {
      return row.isuse == 0 ? "未使用" :"已用";
    },


    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    //点击按钮查询
    clickSearch(formName) {
      this.search();
    },

    //请求APi.获取列表
    search: function () {
      let that = this;
      var da = null;
      if (this.filters.value2 != "" && this.filters.value2 != null) {
        da =
          this.dateFormat(this.filters.value2.toString().split(",")[0]) +
          "," +
          this.dateFormat(this.filters.value2.toString().split(",")[1]);
      }
      //参数
      let params = {
        pageNum: that.page,
        pageSize: 10,
        value: da
      };




      that.loading = true;
      API.getLuckLog(params)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.data.totalSize) {
              that.total = result.data.totalSize;
              that.users = result.data.content;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          //console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    resetForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
    },

    dateFormat(dateData) {
      var date = new Date(dateData);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      const time = y + "-" + m + "-" + d;
      return time;
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>
<style scoped>
::v-deep .el-radio {
  display: block;
  margin: 10px 0;
}
</style>
<style scoped>
::v-deep .el-radio__label {
  color: red;
  margin-right: 10px
}

::v-deep .el-radio__input.is-checked+.el-radio__label {
  color: red !important;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: red !important;
  border-color: red !important;
}
</style>
